module.exports = __webpack_public_path__ + "img/logo.778fe870.png";